import React, { useState } from "react";
import { toast } from "react-toastify";
import { oneKlicks } from "../../../SDK/oneclick";

const HospitalEmailVerify = () => {
    const [isResending, setIsResending] = useState(false);

    const handleResend = async (e) => {
        e.preventDefault();
        setIsResending(true);

        try {
            const userData = JSON.parse(localStorage.getItem("userData"));
            if (!userData || !userData.id) {
                toast.error("User data not found. Please login again.");
                return;
            }

            const tableSchema = "";
            const tableName = "users";
            const conditions = { id: userData.id };
            const data = {
                activation_key: null, // Reset activation key
                is_verified: false
            };

            const response = await oneKlicks.update(tableSchema, tableName, data, conditions);
            
            if (response.success) {
                toast.success("Verification email has been resent. Please check your inbox.");
                // Update local storage with new data
                const updatedUserData = { ...userData, ...data };
                localStorage.setItem("userData", JSON.stringify(updatedUserData));
            } else {
                toast.error("Failed to resend verification email. Please try again.");
            }
        } catch (error) {
            console.error("Error resending verification email:", error);
            toast.error("An error occurred while resending the verification email.");
        } finally {
            setIsResending(false);
        }
    };

    return (
        <div className="dc-haslayout dc-jobalertsdashboard re-sendverification">
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12">
                    <div className="dc-jobalerts">
                        <div className="alert alert-warning fade show">
                            <em>Verification&nbsp;:&nbsp;</em>
                            <span>Your account is not verified. Please check your email for the verification</span>
                            <button
                                className="dc-alertbtn warning"
                                onClick={handleResend}
                                disabled={isResending}
                            >
                                {isResending ? "Sending..." : "Resend email"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HospitalEmailVerify;
